import { EffectsCommandMap } from 'dva';
import { ConnectState } from '@/models/connect';
import { FServiceAPI } from '@freelog/tools-lib';
import fMessage from '@/components/fMessage';
import fPolicyBuilder3 from '@/components/fPolicyBuilder3';
import { PolicyFullInfo_Type } from '@/type/contractTypes';
import type {
  ChangeAction,
  OnClick_step3_addPolicyBtn_Action,
  OnClick_step3_submitBtn_Action,
} from './types';

export const step3Effects = {
  *onClick_step3_addPolicyBtn(
    { payload }: OnClick_step3_addPolicyBtn_Action,
    { select, call, put }: EffectsCommandMap,
  ) {
    self._czc?.push(['_trackEvent', '授权信息页', '添加授权策略', '', 1]);
    const { resourceCreatorPage }: ConnectState = yield select(
      ({ resourceCreatorPage }: ConnectState) => ({
        resourceCreatorPage,
      }),
    );
    const parmas: Parameters<typeof fPolicyBuilder3>[0] = {
      alreadyUsedTexts: resourceCreatorPage.step3_policies.map<string>((ip) => {
        return ip.policyText;
      }),
      alreadyUsedTitles: resourceCreatorPage.step3_policies.map((ip) => {
        return ip.policyName;
      }),
      defaultValue: payload.defaultValue,
      resourceTypeCode: [resourceCreatorPage.step1_createdResourceInfo?.resourceTypeCode || ''],
    };
    const result: null | { title: string; text: string } = yield call(fPolicyBuilder3, parmas);
    if (!result) {
      return;
    }
    const params: Parameters<typeof FServiceAPI.Resource.update>[0] = {
      resourceId: resourceCreatorPage.step1_createdResourceInfo?.resourceID || '',
      addPolicies: [
        {
          policyName: result.title,
          policyText: window.encodeURIComponent(result.text),
        },
      ],
    };
    const {
      ret,
      errCode,
      msg,
      data,
    }: {
      ret: number;
      errCode: number;
      msg: string;
      data: any;
    } = yield call(FServiceAPI.Resource.update, params);

    if (ret !== 0 || errCode !== 0) {
      fMessage(msg, 'error');
      return;
    }

    const params1: Parameters<typeof FServiceAPI.Resource.info>[0] = {
      resourceIdOrName: resourceCreatorPage.step1_createdResourceInfo?.resourceID || '',
      isLoadPolicyInfo: 1,
      isTranslate: 1,
    };

    const {
      data: data_ResourceDetails,
    }: {
      ret: number;
      errCode: number;
      data: {
        resourceId: string;
        resourceName: string;
        policies: any[];
        baseUpcastResources: any[];
        status: 0 | 1;
      };
    } = yield call(FServiceAPI.Resource.info, params1);

    if (ret !== 0 || errCode !== 0) {
      return;
    }

    const policies: PolicyFullInfo_Type[] = data_ResourceDetails.policies || [];

    policies.reverse();

    policies.sort((a, b) => {
      return a.status === 1 && b.status === 0 ? -1 : 0;
    });

    yield put<ChangeAction>({
      type: 'change',
      payload: {
        step3_policies: policies,
      },
    });
  },
  *onClick_step3_submitBtn(
    {}: OnClick_step3_submitBtn_Action,
    { select, call, put }: EffectsCommandMap,
  ) {
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        step: 4,
      },
    });

    const { resourceCreatorPage }: ConnectState = yield select(
      ({ resourceCreatorPage }: ConnectState) => ({
        resourceCreatorPage,
      }),
    );
    const params: Parameters<typeof FServiceAPI.Resource.info>[0] = {
      resourceIdOrName: resourceCreatorPage.step1_createdResourceInfo?.resourceID || '',
      isLoadPolicyInfo: 1,
      isTranslate: 1,
    };
    const {
      data: data_resourceInfo,
    }: {
      data: {
        userId: number;
        status: number;
        resourceId: string;
        resourceName: string;
        resourceTitle: string;
        resourceVersions: {
          version: string;
        }[];
        latestVersion: string;
        coverImages: string[];
        resourceType: string[];
        policies: PolicyFullInfo_Type[];
      };
    } = yield call(FServiceAPI.Resource.info, params);

    yield put<ChangeAction>({
      type: 'change',
      payload: {
        step4_resourceCover: data_resourceInfo.coverImages[0] || '',
      },
    });
  },
};
